import { IClassname } from '@/lib/shared/model/classname';

export const ViewsSVG = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.9732 19.5322L16.6755 17.0392C15.971 16.3715 15.0699 16.0039 14.1375 16.0039C13.2052 16.0039 12.3041 16.3715 11.5995 17.0392L7 22.039"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.8 16.5853C22.5954 16.2871 22.3302 16.0451 22.0253 15.8784C21.7204 15.7118 21.3842 15.625 21.0434 15.625C20.7025 15.625 20.3664 15.7118 20.0615 15.8784C19.7566 16.0451 19.4914 16.2871 19.2868 16.5853L17.9961 18.4669"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.9412 27L8.05882 27C7.77801 27 7.50869 26.878 7.31012 26.6609C7.11155 26.4437 7 26.1492 7 25.8421V6.15789C7 5.8508 7.11155 5.55629 7.31012 5.33914C7.50869 5.12199 7.77801 5 8.05882 5H23.9412C24.222 5 24.4913 5.12199 24.6899 5.33914C24.8884 5.55629 25 5.8508 25 6.15789V25.8421"
        stroke="currentColor"
        strokeWidth="1"
      />
      <path
        d="M7 22.3691L24.6663 22.3691"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="square"
      />
      <path
        d="M17 10C17 10.2626 17.0517 10.5227 17.1522 10.7654C17.2527 11.008 17.4001 11.2285 17.5858 11.4142C17.7715 11.5999 17.992 11.7472 18.2346 11.8478C18.4773 11.9483 18.7374 12 19 12C19.2626 12 19.5227 11.9483 19.7654 11.8478C20.008 11.7472 20.2285 11.5999 20.4142 11.4142C20.5999 11.2285 20.7472 11.008 20.8478 10.7654C20.9483 10.5227 21 10.2626 21 10C21 9.46957 20.7893 8.96086 20.4142 8.58579C20.0391 8.21071 19.5304 8 19 8C18.4696 8 17.9609 8.21071 17.5858 8.58579C17.2107 8.96086 17 9.46957 17 10Z"
        stroke="currentColor"
        strokeWidth="1"
      />
    </svg>
  );
};
